import { Dimensions } from 'react-native';

// Dock yüksekliği, alt konumu ve liste boşluğu aynı geometriden türetilir.
// Güvenli alan ekranda eklenir; home indicator olmayan cihazlarda sıfırdır.
//
// 7.14 / D-700 — beş sekme artık ayrı yuvarlak düğmeler: ortak çubuk yok, bu
// yüzden dikey dolgu sıfır ve yükseklik yuvarlağın kendisi. Batuhan: "Beş ayrı
// düğme olsun şimdilik."
//
// 7.14 / D-777 — düğmeler kilit ekranındaki fener ve kamera düğmelerinin
// boyunda. Batuhan: "Alt bardaki semboller apple'in anasayfasındaki kamera ve el
// feneri boyutunda olabilir". Apple bu ölçüyü yayımlamıyor; iOS 26.5
// simülatörünün kilit ekranı düzenleyicisinde iPhone 17 Pro'da 70 nokta çap
// ölçüldü. Beş düğme 70 noktayla dar ekrana sığmadığından ekran genişliğine
// göre en çok 70'e kadar büyür, en az 50'de kalır. D-784 ayrıca yalnız
// sembolleri 1.25 kat büyütür; düğme, aralık ve rozet geometrisini değiştirmez.
export const lockScreenControlSize = 70;
const minTabSize = 50;
const dockEdge = 16;
const dockGap = 8;

export function dockTabSize(screenWidth: number): number {
  const fit = Math.floor((screenWidth - 2 * dockEdge - 4 * dockGap) / 5);
  return Math.max(minTabSize, Math.min(lockScreenControlSize, fit));
}

const tabSize = dockTabSize(Dimensions.get('window').width || 390);

export const floatingDockMetrics = {
  tabSize,
  tabGap: dockGap,
  verticalPadding: 0,
  bottomOffset: 16,
  contentGap: 16,
  // Rozet yuvarlağın 45 derecedeki kenarına oturur; büyük yuvarlakta kutunun
  // köşesi kenardan uzaklaşır.
  badgeInset: Math.max(0, Math.round((tabSize / 2) * (1 - Math.SQRT1_2) - 8)),
} as const;

export const floatingDockHeight = floatingDockMetrics.tabSize + 2 * floatingDockMetrics.verticalPadding;
export const floatingDockScrollInset = floatingDockHeight + floatingDockMetrics.bottomOffset;
export const floatingDockContentInset = floatingDockScrollInset + floatingDockMetrics.contentGap;
